import React, { useState } from 'react';
import { dashboardAPI } from '../api';

const DataAdmin = () => {
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const showNotification = (type, message) => {
    setNotification({ type, message, timestamp: new Date().toLocaleTimeString() });
    setTimeout(() => setNotification(null), 5000);
  };

  // 1. Eliminar todos los datos de buy_intelligence
  const handleDeleteBuyIntelligence = async () => {
    if (!window.confirm('⚠️ ¿Estás seguro de que quieres eliminar TODOS los datos de buy_intelligence?\n\nEsta operación NO SE PUEDE DESHACER.')) {
      return;
    }

    setLoading(true);
    try {
      const response = await dashboardAPI.proveedores.deleteBuyIntelligence();
      showNotification('success', `✅ ${response.message || 'Todos los datos de buy_intelligence han sido borrados exitosamente.'}`);
    } catch (error) {
      console.error('Error eliminando datos:', error);
      showNotification('error', `❌ Error al eliminar datos: ${error.response?.data?.detail || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // 2. Sincronizar con gashpe
  const [selectedMarketplace, setSelectedMarketplace] = useState('amazon');
  
  const handleSyncGashpe = async () => {
    setLoading(true);
    try {
      const response = await dashboardAPI.proveedores.syncGashpe(selectedMarketplace);
      showNotification('success', `✅ ${response.message || 'Sincronización con GASHPE completada exitosamente.'}`);
      
      if (response.new_records !== undefined) {
        showNotification('info', `📊 Se sincronizaron ${response.new_records} nuevos registros de ${response.total_found || 0} encontrados.`);
      }
    } catch (error) {
      console.error('Error sincronizando con GASHPE:', error);
      showNotification('error', `❌ Error en sincronización: ${error.response?.data?.detail || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // 3. Migrar TODOS los datos a nueva lógica por marcas
  const handleMigrateAllData = async () => {
    if (!window.confirm('🚀 ¿Estás seguro de que quieres migrar TODOS los datos a la nueva lógica por marcas?\n\nEsta operación:\n1. Borrará TODOS los registros existentes\n2. Re-sincronizará completamente\n3. NO SE PUEDE DESHACER')) {
      return;
    }

    setLoading(true);
    try {
      const response = await dashboardAPI.proveedores.migrateAllData();
      showNotification('success', `🎉 ${response.message || 'Migración completada exitosamente.'}`);
      
      if (response.migration_summary) {
        showNotification('info', `📊 Resumen: ${response.migration_summary}`);
      }
    } catch (error) {
      console.error('Error en migración:', error);
      showNotification('error', `❌ Error en migración: ${error.response?.data?.detail || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="data-admin-container" style={{
      padding: 'var(--spacing-xl)',
      backgroundColor: 'var(--color-light-gray)',
      minHeight: '100vh'
    }}>
      <div className="admin-header" style={{
        marginBottom: 'var(--spacing-xl)',
        textAlign: 'center'
      }}>
        <h1 style={{
          color: 'var(--color-primary)',
          fontSize: '2.5rem',
          fontWeight: 'bold',
          marginBottom: 'var(--spacing-md)'
        }}>
          🛠️ Administración de Datos
        </h1>
        <p style={{
          color: 'var(--color-text-secondary)',
          fontSize: '1.1rem',
          maxWidth: '600px',
          margin: '0 auto'
        }}>
          Herramientas avanzadas para la gestión y sincronización de datos del sistema
        </p>
      </div>

      {/* Notificación */}
      {notification && (
        <div className={`notification ${notification.type}`} style={{
          padding: 'var(--spacing-md)',
          marginBottom: 'var(--spacing-lg)',
          borderRadius: 'var(--border-radius)',
          border: '1px solid',
          backgroundColor: notification.type === 'success' ? 'var(--color-success-light)' : 
                         notification.type === 'error' ? 'var(--color-error-light)' : 
                         'var(--color-info-light)',
          borderColor: notification.type === 'success' ? 'var(--color-success)' : 
                      notification.type === 'error' ? 'var(--color-error)' : 
                      'var(--color-info)',
          color: notification.type === 'success' ? 'var(--color-success-dark)' : 
                 notification.type === 'error' ? 'var(--color-error-dark)' : 
                 'var(--color-info-dark)'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>{notification.message}</span>
            <small style={{ opacity: 0.7 }}>{notification.timestamp}</small>
          </div>
        </div>
      )}

      <div className="admin-actions" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
        gap: 'var(--spacing-lg)',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        
        {/* Opción 1: Eliminar datos buy_intelligence */}
        <div className="admin-card danger" style={{
          backgroundColor: 'var(--color-white)',
          borderRadius: 'var(--border-radius-lg)',
          padding: 'var(--spacing-xl)',
          boxShadow: 'var(--shadow-medium)',
          border: '2px solid var(--color-error)',
          position: 'relative'
        }}>
          <div className="card-header" style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: 'var(--spacing-lg)'
          }}>
            <div className="icon" style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              backgroundColor: 'var(--color-error)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: 'var(--spacing-md)'
            }}>
              <span style={{ color: 'white', fontSize: '1.5rem' }}>⚠️</span>
            </div>
            <div>
              <h3 style={{
                color: 'var(--color-error)',
                margin: 0,
                fontSize: '1.3rem',
                fontWeight: 'bold'
              }}>
                Eliminar todos los datos de buy_intelligence
              </h3>
              <p style={{
                color: 'var(--color-text-secondary)',
                margin: 'var(--spacing-xs) 0 0 0',
                fontSize: '0.9rem'
              }}>
                Operación destructiva
              </p>
            </div>
          </div>

          <div className="card-content" style={{ marginBottom: 'var(--spacing-lg)' }}>
            <p style={{
              color: 'var(--color-text)',
              lineHeight: '1.6',
              marginBottom: 'var(--spacing-md)'
            }}>
              Esta operación eliminará <strong>TODOS</strong> los registros de la tabla 
              <code>buy_intelligence</code> de la base de datos.
            </p>
            
            <div className="warning-box" style={{
              backgroundColor: 'var(--color-error-light)',
              border: '1px solid var(--color-error)',
              borderRadius: 'var(--border-radius)',
              padding: 'var(--spacing-md)',
              marginBottom: 'var(--spacing-md)'
            }}>
              <strong style={{ color: 'var(--color-error)' }}>⚠️ ADVERTENCIA:</strong>
              <ul style={{ margin: 'var(--spacing-sm) 0 0 var(--spacing-md)', color: 'var(--color-error-dark)' }}>
                <li>Esta operación NO SE PUEDE DESHACER</li>
                <li>Se perderán todos los datos de inteligencia de compra</li>
                <li>Requiere confirmación explícita</li>
              </ul>
            </div>
          </div>

          <button
            onClick={handleDeleteBuyIntelligence}
            disabled={loading}
            style={{
              width: '100%',
              padding: 'var(--spacing-md)',
              backgroundColor: 'var(--color-error)',
              color: 'white',
              border: 'none',
              borderRadius: 'var(--border-radius)',
              fontSize: '1rem',
              fontWeight: 'bold',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1,
              transition: 'all 0.3s ease'
            }}
          >
            {loading ? '🗑️ Eliminando...' : '🗑️ Borrar todos los datos buy_intelligence'}
          </button>
        </div>

        {/* Opción 2: Sincronizar con gashpe */}
        <div className="admin-card sync" style={{
          backgroundColor: 'var(--color-white)',
          borderRadius: 'var(--border-radius-lg)',
          padding: 'var(--spacing-xl)',
          boxShadow: 'var(--shadow-medium)',
          border: '2px solid var(--color-info)',
          position: 'relative'
        }}>
          <div className="card-header" style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: 'var(--spacing-lg)'
          }}>
            <div className="icon" style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              backgroundColor: 'var(--color-info)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: 'var(--spacing-md)'
            }}>
              <span style={{ color: 'white', fontSize: '1.5rem' }}>🔄</span>
            </div>
            <div>
              <h3 style={{
                color: 'var(--color-info)',
                margin: 0,
                fontSize: '1.3rem',
                fontWeight: 'bold'
              }}>
                Sincronizar con gashpe
              </h3>
              <p style={{
                color: 'var(--color-text-secondary)',
                margin: 'var(--spacing-xs) 0 0 0',
                fontSize: '0.9rem'
              }}>
                Obtener publicaciones faltantes
              </p>
            </div>
          </div>

          <div className="card-content" style={{ marginBottom: 'var(--spacing-lg)' }}>
            <p style={{
              color: 'var(--color-text)',
              lineHeight: '1.6',
              marginBottom: 'var(--spacing-md)'
            }}>
              Sincroniza con la base de datos GASHPE para obtener información de 
              publicaciones y proveedores usando la nueva lógica por marcas.
            </p>
            
            {/* Selector de Marketplace */}
            <div style={{ marginBottom: 'var(--spacing-md)' }}>
              <label style={{
                display: 'block',
                marginBottom: 'var(--spacing-sm)',
                color: 'var(--color-text)',
                fontWeight: 'bold'
              }}>
                Marketplace:
              </label>
              <select
                value={selectedMarketplace}
                onChange={(e) => setSelectedMarketplace(e.target.value)}
                style={{
                  width: '100%',
                  padding: 'var(--spacing-sm)',
                  borderRadius: 'var(--border-radius)',
                  border: '1px solid var(--color-border)',
                  backgroundColor: 'var(--color-white)',
                  color: 'var(--color-text)',
                  fontSize: '1rem'
                }}
              >
                <option value="amazon">Amazon</option>
                <option value="mercadolibre">MercadoLibre</option>
              </select>
            </div>
            
            <div className="info-box" style={{
              backgroundColor: 'var(--color-info-light)',
              border: '1px solid var(--color-info)',
              borderRadius: 'var(--border-radius)',
              padding: 'var(--spacing-md)',
              marginBottom: 'var(--spacing-md)'
            }}>
              <strong style={{ color: 'var(--color-info)' }}>ℹ️ Información:</strong>
              <ul style={{ margin: 'var(--spacing-sm) 0 0 var(--spacing-md)', color: 'var(--color-info-dark)' }}>
                <li>Conecta con base de datos GASHPE</li>
                <li>Usa lógica por marcas (brands → vendors)</li>
                <li>Agrega solo registros nuevos</li>
                <li>No afecta datos existentes</li>
                <li>Verifica duplicados antes de insertar</li>
              </ul>
            </div>
          </div>

          <button
            onClick={handleSyncGashpe}
            disabled={loading}
            style={{
              width: '100%',
              padding: 'var(--spacing-md)',
              backgroundColor: 'var(--color-info)',
              color: 'white',
              border: 'none',
              borderRadius: 'var(--border-radius)',
              fontSize: '1rem',
              fontWeight: 'bold',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1,
              transition: 'all 0.3s ease'
            }}
          >
            {loading ? '🔄 Sincronizando...' : '🔄 Sincronizar con gashpe'}
          </button>
        </div>

        {/* Opción 3: Migrar todos los datos */}
        <div className="admin-card migrate" style={{
          backgroundColor: 'var(--color-white)',
          borderRadius: 'var(--border-radius-lg)',
          padding: 'var(--spacing-xl)',
          boxShadow: 'var(--shadow-medium)',
          border: '2px solid var(--color-warning)',
          position: 'relative'
        }}>
          <div className="card-header" style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: 'var(--spacing-lg)'
          }}>
            <div className="icon" style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              backgroundColor: 'var(--color-warning)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: 'var(--spacing-md)'
            }}>
              <span style={{ color: 'white', fontSize: '1.5rem' }}>🔄</span>
            </div>
            <div>
              <h3 style={{
                color: 'var(--color-warning)',
                margin: 0,
                fontSize: '1.3rem',
                fontWeight: 'bold'
              }}>
                Migrar TODOS los datos a nueva lógica por marcas
              </h3>
              <p style={{
                color: 'var(--color-text-secondary)',
                margin: 'var(--spacing-xs) 0 0 0',
                fontSize: '0.9rem'
              }}>
                Migración completa del sistema
              </p>
            </div>
          </div>

          <div className="card-content" style={{ marginBottom: 'var(--spacing-lg)' }}>
            <p style={{
              color: 'var(--color-text)',
              lineHeight: '1.6',
              marginBottom: 'var(--spacing-md)'
            }}>
              Migración completa que reemplaza todos los datos existentes con la nueva 
              lógica de asignación de proveedores por marcas.
            </p>
            
            <div className="migration-info" style={{
              backgroundColor: 'var(--color-warning-light)',
              border: '1px solid var(--color-warning)',
              borderRadius: 'var(--border-radius)',
              padding: 'var(--spacing-md)',
              marginBottom: 'var(--spacing-md)'
            }}>
              <strong style={{ color: 'var(--color-warning)' }}>🚀 Migración Completa:</strong>
              <ul style={{ margin: 'var(--spacing-sm) 0 0 var(--spacing-md)', color: 'var(--color-warning-dark)' }}>
                <li>Borra TODOS los registros existentes</li>
                <li>Re-sincroniza con nueva lógica por marcas</li>
                <li>Mejora precisión de 50.2% a 1.2% desconocidas</li>
                <li>NO SE PUEDE DESHACER</li>
              </ul>
            </div>

            <div className="impact-preview" style={{
              backgroundColor: 'var(--color-success-light)',
              border: '1px solid var(--color-success)',
              borderRadius: 'var(--border-radius)',
              padding: 'var(--spacing-md)'
            }}>
              <strong style={{ color: 'var(--color-success)' }}>📊 Impacto Esperado:</strong>
              <div style={{ marginTop: 'var(--spacing-sm)', color: 'var(--color-success-dark)' }}>
                <div>Amazon: 5,694 → 159 desconocidas (-5,582 mejora)</div>
                <div>MercadoLibre: 3,101 → 103 desconocidas (-2,998 mejora)</div>
                <div><strong>TOTAL: 8,795 → 215 desconocidas (-8,580 GRAN MEJORA)</strong></div>
              </div>
            </div>
          </div>

          <button
            onClick={handleMigrateAllData}
            disabled={loading}
            style={{
              width: '100%',
              padding: 'var(--spacing-md)',
              backgroundColor: 'var(--color-warning)',
              color: 'white',
              border: 'none',
              borderRadius: 'var(--border-radius)',
              fontSize: '1rem',
              fontWeight: 'bold',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1,
              transition: 'all 0.3s ease'
            }}
          >
            {loading ? '🚀 Migrando...' : '🚀 MIGRAR TODOS LOS DATOS'}
          </button>
        </div>
      </div>

      {/* Información adicional */}
      <div className="admin-info" style={{
        marginTop: 'var(--spacing-xl)',
        padding: 'var(--spacing-lg)',
        backgroundColor: 'var(--color-white)',
        borderRadius: 'var(--border-radius-lg)',
        boxShadow: 'var(--shadow-medium)',
        maxWidth: '1200px',
        margin: 'var(--spacing-xl) auto 0'
      }}>
        <h3 style={{
          color: 'var(--color-primary)',
          marginBottom: 'var(--spacing-md)'
        }}>
          📋 Información del Sistema
        </h3>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: 'var(--spacing-lg)'
        }}>
          <div>
            <h4 style={{ color: 'var(--color-text)', marginBottom: 'var(--spacing-sm)' }}>
              🔗 Nueva Lógica por Marcas
            </h4>
            <p style={{ color: 'var(--color-text-secondary)', fontSize: '0.9rem', lineHeight: '1.5' }}>
              <code>publications.sku → products.brand → brands.name → brands.vendor_id → vendors.name</code>
            </p>
          </div>
          
          <div>
            <h4 style={{ color: 'var(--color-text)', marginBottom: 'var(--spacing-sm)' }}>
              📊 Beneficios de la Migración
            </h4>
            <ul style={{ color: 'var(--color-text-secondary)', fontSize: '0.9rem', lineHeight: '1.5' }}>
              <li>Amazon: 94.7% → 1.9% desconocidas</li>
              <li>MercadoLibre: 26.9% → 0.9% desconocidas</li>
              <li>Relación más precisa por marca</li>
              <li>Mejor trazabilidad producto-proveedor</li>
            </ul>
          </div>
          
          <div>
            <h4 style={{ color: 'var(--color-text)', marginBottom: 'var(--spacing-sm)' }}>
              ⚠️ Consideraciones Importantes
            </h4>
            <ul style={{ color: 'var(--color-text-secondary)', fontSize: '0.9rem', lineHeight: '1.5' }}>
              <li>Hacer backup antes de operaciones destructivas</li>
              <li>Verificar conectividad con GASHPE</li>
              <li>Las migraciones pueden tardar varios minutos</li>
              <li>Revisar logs en caso de errores</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataAdmin;
